import styled from "styled-components";
import { transparentize } from "polished";

import { theme } from "@/style";

const HEIGHT = 38;
const INDICATOR_WIDTH = 32;
const OPTION_MIN_HEIGHT = 38;
const OPTION_HOVER_BG = transparentize(0.85, theme.PrimaryColor);
const OPTION_SELECTED_BG = transparentize(0.9, theme.PrimaryColor);

export const Wrapper = styled.div`
    position: relative;
    display: ${(p) => (p.$block ? "flex" : "inline-flex")};
    flex-direction: column;
    width: ${(p) => (p.$block ? "100%" : "auto")};
    min-height: ${HEIGHT}px;

    /* Match flexibull2 Select layout when used in product integration forms */
    &.async-select {
        width: auto;
        min-width: 0;
    }
`;

export const Label = styled.span`
    display: block;
    position: absolute;
    top: -20px;
    font-weight: 600;
    font-size: 0.95em;
    color: ${theme.PrimaryFontColor};
    cursor: default;
`;

export const Trigger = styled.button`
    display: grid;
    grid-template-columns: 1fr ${INDICATOR_WIDTH}px;
    align-items: center;
    height: ${HEIGHT}px;
    padding: 0 10px;
    border: 1px solid ${theme.PrimaryBorderColor};
    border-radius: ${theme.PrimaryRadius};
    background: ${(p) => (p.$disabled ? theme.PrimaryInputDisabled : "#fff")};
    color: ${theme.PrimaryFontColor};
    font-size: ${theme.PrimaryFontSize};
    line-height: 1;
    text-align: left;
    cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
    width: 100%;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${theme.PrimaryInputOutline};
    }

    ${(p) =>
        p.$isOpen &&
        `
        border-color: ${theme.PrimaryInputOutline};
    `}

    ${(p) =>
        p.$disabled &&
        `
        border-style: dashed;
    `}
`;

export const TriggerValue = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${theme.PrimaryFontColor};
`;

export const TriggerPlaceholder = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${theme.PrimaryGrey};
`;

export const Indicator = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${INDICATOR_WIDTH}px;
    height: 100%;
    transform: rotateZ(${(p) => (p.$isOpen ? "180deg" : "0deg")});
    transition: transform 0.2s ease;
    color: ${theme.PrimaryGrey};
`;

export const Menu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    padding: 0;
    background: #fff;
    border: 1px solid ${theme.PrimaryBorderColor};
    border-radius: ${theme.PrimaryRadius};
    box-shadow: ${theme.Elevation.Sm};
    z-index: 10;
    max-height: 16em;
    display: flex;
    flex-direction: column;
`;

export const SearchInput = styled.input`
    padding: 10px;
    border: none;
    border-bottom: 1px solid ${theme.PrimaryBorderColor};
    border-radius: ${theme.PrimaryRadius} ${theme.PrimaryRadius} 0 0;
    background: #fff;
    font-size: ${theme.PrimaryFontSize};
    color: ${theme.PrimaryFontColor};

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: ${theme.PrimaryGrey};
    }
`;

export const OptionList = styled.div`
    padding: 0;
    overflow-y: auto;
    max-height: 12em;
`;

export const Option = styled.div`
    min-height: ${OPTION_MIN_HEIGHT}px;
    display: grid;
    align-items: center;
    padding: 0 10px;
    cursor: ${(p) => (p.$empty ? "default" : "pointer")};
    font-size: ${theme.PrimaryFontSize};
    color: ${theme.PrimaryFontColor};

    &:hover,
    &:active {
        background-color: ${(p) => (p.$empty ? "transparent" : OPTION_HOVER_BG)};
    }

    ${(p) =>
        p.$selected &&
        `
        background-color: ${OPTION_SELECTED_BG};
        font-weight: 500;
    `}
`;

export const Error = styled.span`
    position: absolute;
    display: block;
    top: 110%;
    left: 0;
    color: ${theme.PrimaryRed};
    font-size: 0.9em;
    font-style: italic;
    cursor: default;
`;
